import { render, staticRenderFns } from "./company-info.html?vue&type=template&id=0c29e761&scoped=true&external"
import script from "./company-info.js?vue&type=script&lang=js&external"
export * from "./company-info.js?vue&type=script&lang=js&external"
import style0 from "./company-info.scss?vue&type=style&index=0&id=0c29e761&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29e761",
  null
  
)

export default component.exports